import { useCallback } from 'react';
import prettier from 'prettier/standalone';
import parserTypescript from 'prettier/parser-typescript';
import { getLanguage } from '../utils';
import { useUI, useEditorState } from '../contexts';

type UseFormatParams = {
  resolvePath: (id: string) => string;
  setWorkingFiles: React.Dispatch<React.SetStateAction<Record<string, string>>>;
};

export function useFormat({
  resolvePath,
  setWorkingFiles,
}: UseFormatParams) {
  // Get UI state from context
  const { setStatus } = useUI();

  // Get editor state from context
  const { activeFile, code, setCode } = useEditorState();
  const handleFormat = useCallback(() => {
    if (!activeFile) return false;
    const path = resolvePath(activeFile);
    const language = getLanguage(path);
    if (language !== 'typescript' && language !== 'javascript') {
      setStatus('Format skipped · unsupported file');
      return false;
    }
    try {
      const formatted = prettier.format(code, {
        parser: 'typescript',
        plugins: [parserTypescript],
        semi: true,
        singleQuote: true,
      });
      setCode(formatted);
      setWorkingFiles((prev) => ({ ...prev, [activeFile]: formatted }));
      setStatus(`Formatlandı · Prettier (${path})`);
      return true;
    } catch (error) {
      console.error('Format error', error);
      setStatus('Format hatası');
      return false;
    }
  }, [activeFile, code, resolvePath, setCode, setWorkingFiles, setStatus]);

  return { handleFormat };
}
